
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Modified_EIlis_Classification_of_Tibial_Fractures',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Modified_EIlis_Classification_of_Tibial_Fractures.vue